import clsx from "clsx";

import styles from "../../product-card.module.css";

const Description = ({ children }: { children: React.ReactNode }) => (
  <div className={clsx(styles["product-card__desc"])}>{children}</div>
);

export default Description;
